import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({
    actions: {

        confirmAge({ commit }, payload) {
            commit('confirmAge', payload)
        },

        openPopup({ commit }, payload) {
            commit('openPopup', payload)
        },

        closePopup({ commit }, payload) {
            commit('closePopup', payload)
        }

    },


    getters: {
        ageConfirmed: state => {
            return state.ageConfirmed
        },

        popupShown: state => {
            return state.popupShown
        }

    },


    mutations: {
        confirmAge(state, message) {
            state.ageConfirmed = true
        },

        openPopup(state, message) {
            state.popupShown = true
        },

        closePopup(state, message) {
            state.popupShown = false
        }
    },

    state: {
        ageConfirmed: false,
        underAge: false,
        popupShown: false
    }
})



// WEBPACK FOOTER //
// ./src/js/store.js